import React from 'react';
import { BoxProps, TextV2 } from '@withjoy/joykit';
import { StyledBox } from './HeroText.styles';
import { SkeletonText } from '@shared/components/Skeleton';

interface HeroTextProps {
  heroText?: string | null;
  margin?: BoxProps['margin'];
  textAlign?: BoxProps['textAlign'];
  maxWidth?: BoxProps['marginBottom'];
}

export const HeroText: React.FC<HeroTextProps> = ({ textAlign = 'center', maxWidth = '595px', heroText, margin = '0 auto 64px' }) => {
  return (
    <StyledBox
      maxWidth={maxWidth}
      margin={margin}
    >
      {heroText && (
        <TextV2
          component="h1"
          textAlign={textAlign}
          typographyVariant={['HedMobile32', null, 'Hed56']}
        >
          {heroText}
        </TextV2>
      )}
    </StyledBox>
  );
};

export const HeroTextWithSkeleton = ({
  shouldRevealSkeleton,
  skeletonRowCount,
  heroText,
  placeholderProps,
  textAlign,
  margin,
}: {
  shouldRevealSkeleton: boolean;
  skeletonRowCount: number;
  heroText: Maybe<string>;
  placeholderProps?: BoxProps;
  textAlign?: 'center' | 'left';
  margin?: BoxProps['margin'];
}) => {
  return (
    <SkeletonText
      isReady={shouldRevealSkeleton}
      rows={skeletonRowCount}
      enableVaryingRowWidth={true}
      rowWidths={[100, 85]}
      skeletonHeight={['18px', null, '28px']}
      spacing={'32px'}
      overrides={{
        PlaceholderRoot: {
          props: {
            marginTop: [3, null, 8],
            marginBottom: ['62px', null, '46px'],
            height: [null, null, '136px'],
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '560px',
            maxWidth: '90%',
            marginX: 'auto',
            ...placeholderProps,
          },
        },
      }}
    >
      <HeroText
        heroText={heroText}
        margin={margin}
        textAlign={textAlign}
      />
    </SkeletonText>
  );
};
